/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const vehicleManage = {
  path: '/vehicle-manage',
  component: Layout,
  redirect: '/vehicle-manage/fleet-management',
  name: 'VehicleManage',
  meta: {
    title: 'vehicleManage',
    icon: 'qiche',
    perm: 'cSiteLrpManage'
  },
  children: [
    {
      path: 'white-list',
      component: () => import('@/views/device/license-plate-recognition/white-list/whiteList.vue'),
      name: 'WhiteList',
      meta: { title: 'whiteList', perm: 'cSiteLprWhiteListManager' }
    },
    {
      path: 'license-plate-recognition',
      component: () => import('@/views/device/license-plate-recognition/device-list/deviceList.vue'),
      name: 'LicensePlateRecognition',
      meta: { title: 'licensePlateRecognition', perm: 'cSiteLprDeviceManager' }
    },
    {
      path: 'lpr-record',
      component: () => import('@/views/statistics/lpr-record/index.vue'),
      name: 'LPRRecord',
      meta: { title: 'lPRRecord', perm: 'cSiteLprRecordManager' }
    },
    {
      path: 'fleet-management',
      component: () => import('@/views/manage/fleet-management/index.vue'),
      name: 'FleetManagement',
      meta: { title: 'fleetManagement', perm: 'cSiteFleetManage' }
    }

  ]
}
export default vehicleManage
